var animationDurationVar = 'var(--fx_2d2fb1e5_1mjtb9o1)';
var animationNameVar = 'var(--fx_2d2fb1e5_1mjtb9o0)';
var animationTimingFunctionVar = 'var(--fx_2d2fb1e5_1mjtb9o2)';
var root = 'fx_2d2fb1e5_1mjtb9o3';

export { animationDurationVar, animationNameVar, animationTimingFunctionVar, root };
//# sourceMappingURL=animationController.vanilla.mjs.map
